import { useIsAuthenticated } from "@azure/msal-react";
import { Navigate, Outlet } from "react-router-dom";

const RequireAuth = ({ isAuthPage = false }) => {
  const isAuth = useIsAuthenticated();


  if (isAuthPage) {
    return !isAuth ? <Outlet /> : <Navigate to="/" replace />;
  }
  return isAuth ? <Outlet /> : <Navigate to="/auth/login" replace />;
};

export default RequireAuth;
